import { Charges } from '@/v2/services/availability/types/api/parsedResponse';

const getSign = (baseAmount: number, targetAmount: number) => {
  if (targetAmount >= baseAmount) {
    return '+';
  }
  if (targetAmount < baseAmount) {
    return '-';
  }
  return '';
};

interface PriceCharge {
  perTraveller: Charges['perTraveller'];
}

interface GetPriceDifference {
  selectedOption: PriceCharge;
  option: PriceCharge;
}

const getPriceDifference = ({ selectedOption, option }: GetPriceDifference) => {
  const baseAmount = selectedOption.perTraveller.amount;
  const targetAmount = option.perTraveller.amount;

  const amount = Math.abs(targetAmount - baseAmount);

  const sign = getSign(baseAmount, targetAmount);

  return {
    amount,
    sign,
  };
};

export default getPriceDifference;
